import { Helmet } from 'react-helmet-async';
import { Hero } from './Hero';
import { Services } from './Services';
import { WhyChooseUs } from './WhyChooseUs';
import { Process } from './Process';
import { Industries } from './Industries';
import { Compliance } from './Compliance';
import { FAQ } from './FAQ';
import { Testimonials } from './Testimonials';
import { Contact } from './Contact';

export const HomePage = () => (
  <>
    <Helmet prioritizeSeoTags>
      <title>Advanced ADAS Calibrations | ADAS Calibration Adelaide & South Australia</title>
      <meta name="description" content="Independent mobile ADAS calibration in Adelaide & SA. OEM-compliant camera and radar calibration with insurer-ready reports for repairers, fleets and insurers." />
      <link rel="canonical" href="https://advancedadas.com.au/" />
      <meta property="og:title" content="Advanced ADAS Calibrations | Independent ADAS Calibration Specialists" />
      <meta property="og:description" content="OEM-compliant ADAS calibration services for South Australia. Trusted by insurers, collision repairers, and fleet operators." />
      <meta property="og:url" content="https://advancedadas.com.au/" />
    </Helmet>
    <main>
      <Hero />
      <Services />
      <WhyChooseUs />
      <Process />
      <Industries />
      <Compliance />
      <FAQ />
      <Testimonials />
      <Contact />
    </main>
  </>
);
